import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import JobsPage from './pages/JobsPage';
import ErrorsPage from './pages/ErrorsPage';
import FeedbackPage from './pages/FeedbackPage';
import ReprocessPage from './pages/ReprocessPage';

const ADMIN_EMAIL = 'tod@todfather.com';
type Screen = 'loading' | 'login' | 'denied' | 'app';

export default function App() {
  const [screen, setScreen] = useState<Screen>('loading');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    checkSession();
  }, []);

  async function checkSession() {
    try {
      const session = await fetchAuthSession();
      const email = (session.tokens?.idToken?.payload?.email as string | undefined ?? '').toLowerCase();
      if (!email) {
        setScreen('login');
        return;
      }
      if (email !== ADMIN_EMAIL) {
        await signOut();
        setScreen('denied');
        return;
      }
      setUserEmail(email);
      setScreen('app');
    } catch {
      setScreen('login');
    }
  }

  if (screen === 'loading') {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        color: 'var(--text-muted)',
        fontSize: 13,
      }}>
        Loading…
      </div>
    );
  }

  if (screen === 'denied') {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
      }}>
        <div style={{
          width: 360,
          background: 'var(--danger-subtle)',
          border: '1px solid var(--danger)',
          borderRadius: 12,
          padding: 32,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--danger)', marginBottom: 8 }}>
            Access Denied
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
            This console is restricted to the global admin account.
          </div>
          <button
            onClick={() => setScreen('login')}
            style={{
              padding: '8px 20px',
              background: 'var(--danger)',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Sign out & try again
          </button>
        </div>
      </div>
    );
  }

  if (screen === 'login') {
    return (
      <LoginPage
        onSuccess={() => checkSession()}
        onDenied={() => setScreen('denied')}
      />
    );
  }

  // screen === 'app'
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AdminLayout userEmail={userEmail} />}>
          <Route index element={<DashboardPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="errors" element={<ErrorsPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="reprocess" element={<ReprocessPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
